import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { reduce } from 'underscore';
import { ShopCaseLink } from 'app/modules/shop/components/shopCase';
import { LoginLink } from 'app/modules/auth/components/login';
import { NavbarItem } from 'app/components/navbar/NavbarItem';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { Context } from '../index';
import { NavbarItemMobile } from './navbar/NavbarItemMobile';

function mapStateToProps(state) {
    return {
        setting: state.appState.setting,
        products: state.shopState.shopCase.products,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onClick: () => dispatch(onCardClick()),
    };
}

function openShopCase() {
    return (dispatch) => {
        dispatch({
            type: 'openRightModal',
            HeadItem: ['Корзина'],
            children: <ShopCaseLink />,
            onClose: () => {
                dispatch({ type: 'closeRightModal' });
            },
        });
    };
}

function openLogin(onAfterLogin) {
    return (dispatch) => {
        dispatch({
            type: 'openMiniModal',
            header: 'Вход',
            children: <LoginLink onAfterLogin={onAfterLogin || (() => {})} />,
            onClose: () => {
                dispatch({ type: 'closeMiniModal' });
            },
        });
    };
}

function onCardClick() {
    return (dispatch, getState) => {
        const state = getState();
        const user = state.authState.user;
        const isAuthRequired = state.pointsState.isAuthRequired;
        function openShop() {
            dispatch(openShopCase());
        }
        user || !isAuthRequired ? openShop() : dispatch(openLogin(openShop));
    };
}

export const ConnectedCart = connect(
    mapStateToProps,
    mapDispatchToProps
)(({ products, onClick, setting, mobile }) => {
    const { cart } = useContext(Context);
    const quantity = reduce(
        products,
        (memo, product) => {
            return memo + Number(product.qty);
        },
        0
    );
    const { color, colorSvg } = setting.sidebar.itemShop;
    const blockStyle = {
        color,
    };
    const iconStyle = {
        color: colorSvg,
    };
    const Container = mobile ? NavbarItemMobile : NavbarItem;
    return (
        <Container
            ref={cart}
            name={'Корзина'}
            icon={<ShoppingCartOutlined />}
            info={quantity}
            showInfo={quantity > 0}
            onClick={onClick}
        />
    );
});
